module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [(_vm.editUserClient.id) ? _c('div', [_c('h3', [_vm._v("Mitarbeiter/Abbteilung/Thema bearbeiten")]), _vm._v(" "), _c('small', {
    staticClass: "text-right"
  }, [_vm._v("Link: {intern::" + _vm._s(_vm.editUserClient.id) + "::" + _vm._s(_vm.editUserClient.lastName) + " " + _vm._s(_vm.editUserClient.department) + " " + _vm._s(_vm.userClient.function) + "}")])]) : _c('h3', [_vm._v("Neuen 'Mitarbeiter/Abbteilung/Thema anlegen")]), _vm._v(" "), (false) ? _c('div', [_vm._v("\n                idCompany: " + _vm._s(_vm.editUserClient.idCompany) + "\n                idUser: " + _vm._s(_vm.editUserClient.idUserClient) + "\n              ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('form', {
    attrs: {
      "id": _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel', _vm.userClient)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "userclient-art"
    }
  }, [_vm._v("Art:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.idSex),
      expression: "editUserClient.idSex"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "userclient-art",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserClient, "idSex", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.UserConf.ART), function(option) {
    return _c('option', {
      domProps: {
        "value": option.VALUE
      }
    }, [_vm._v("\n                      " + _vm._s(option.TEXT) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editUserClient.idSex < 3),
      expression: "editUserClient.idSex < 3"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "userclient-title"
    }
  }, [_vm._v("Titel:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.idPertitel),
      expression: "editUserClient.idPertitel"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "userclient-title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserClient, "idPertitel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.UserConf.PERTITEL), function(option) {
    return _c('option', {
      domProps: {
        "value": option.VALUE
      }
    }, [_vm._v("\n                      " + _vm._s(option.TEXT) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.editUserClient.idSex < 3) ? _c('label', {
    attrs: {
      "for": "userclient-firstname"
    }
  }, [_vm._v("Vorname:")]) : _c('label', {
    attrs: {
      "for": "userclient-firstname"
    }
  }, [_vm._v("Beschreibung:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.firstName),
      expression: "editUserClient.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "userclient-firstname",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.editUserClient.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserClient, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.editUserClient.idSex < 3) ? _c('label', {
    attrs: {
      "for": "userclient-lastname"
    }
  }, [_vm._v("Nachname:")]) : _c('label', {
    attrs: {
      "for": "userclient-lastname"
    }
  }, [_vm._v("Beschreibung:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.lastName),
      expression: "editUserClient.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "id": "userclient-lastname",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.editUserClient.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserClient, "lastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "userclient-department"
    }
  }, [_vm._v("Abteilung:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.department),
      expression: "editUserClient.department"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "userclient-department",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.editUserClient.department)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserClient, "department", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "userclient-function"
    }
  }, [_vm._v("Funktion:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.function),
      expression: "editUserClient.function"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "userclient-function",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.editUserClient.function)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserClient, "function", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "userclient-room"
    }
  }, [_vm._v("Zimmer/Ort::")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.room),
      expression: "editUserClient.room"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "userclient-room",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.editUserClient.room)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserClient, "room", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "userclient-calltemplate"
    }
  }, [_vm._v("Vorlage:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserClient.calltemplate),
      expression: "editUserClient.calltemplate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "userclient-calltemplate",
      "rows": "6",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.editUserClient.calltemplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserClient, "calltemplate", $event.target.value)
      }
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "form": _vm._uid
    }
  }, [_vm._v("\n                Speichern\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel', _vm.userClient)
      }
    }
  }, [_vm._v("\n                Abbrechen\n              ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-584ebfc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserClientModal.vue
// module id = 277
// module chunks = 0